<template>
  <div class="review-detail">
    <!-- 申请单详情 -->
    <NavHeaderBar :showSearch="false" navBarTitle="Application form details"></NavHeaderBar>
    <div class="detail-info">
      <div class="info-item van-ellipsis">
        <!-- 申请时间 -->
        <span>{{ $t('shared.timeOfApplication') }}：</span>
        <span>{{ reviewInfo.localCreateTime }}</span>
      </div>
      <div class="info-item van-ellipsis">
        <!-- 申请人： -->
        <span>{{ $t('shared.applicant') }}：</span>
        <span>{{ reviewInfo.createUserName }}</span>
      </div>
      <div class="info-item van-ellipsis">
        <!-- 门店ID： -->
        <span>{{ $t('shared.storeID') }}：</span>
        <span>{{ reviewInfo.customerCode }}</span>
      </div>
      <div class="info-item van-ellipsis" v-if="!['', null].includes(reviewInfo.customerTag)">
        <!-- 门店等级： -->
        <span>{{ $t('shared.storesLevel') }}：</span>
        <span>{{ reviewInfo.customerTag | formatTag }}</span>
      </div>
      <div class="info-item van-ellipsis store-name">
        <!-- 门店名称： -->
        <span>{{ $t('form.storeName') }}：</span>
        <span class="store-name" @click="toPage(`/storeMaintain/storeMappingDetail?customerId=${reviewInfo.customerId}&pageType=storeMaintain&activityType=71`)">{{ reviewInfo.customerName }}</span>
      </div>
      <div class="info-item">
        <!-- 放弃原因： -->
        <span>{{ $t('shared.giveUpReason') }}：</span>
        <span>{{ reviewInfo.submitNote }}</span>
      </div>
      <div class="info-item van-ellipsis">
        <!-- 审核状态： -->
        <span>{{ $t('shared.reviewStatus') }}：</span>
        <span class="status-txt" :class="{'status10': reviewInfo.status === 10, 'status_1': reviewInfo.status === -1}">{{ reviewInfo.status | formatStatus }}</span>
      </div>
      <div class="info-item van-ellipsis" v-if="reviewInfo.status != 1">
        <!-- 审批人： -->
        <span>{{ $t('shared.approver') }}：</span>
        <span>{{ reviewInfo.auditUserName }}</span>
      </div>
      <div class="info-item van-ellipsis" v-if="reviewInfo.status != 1">
        <!-- 审批时间： -->
        <span>{{ $t('shared.approvalTime') }}：</span>
        <span>{{ reviewInfo.localAuditTime }}</span>
      </div>
    </div>
    <div class="oper-bottom-btn" v-if="reviewInfo.status === 1 && this.checkPer(['admin', 'app:audit:check'])">
      <!-- 拒绝 -->
      <van-button class="left-btn" :loading="isLoading" :loading-text="$t('button.reject')" @click="handleOper('refuse')">{{ $t('button.reject') }}</van-button>
      <!-- 同意 -->
      <van-button class="right-btn" :loading="isLoading" :loading-text="$t('button.agree')" @click="handleOper('agree')">{{ $t('button.agree') }}</van-button>
    </div>
  </div>
</template>

<script>
import { auditInfoApi, auditCheckGiveUpCustomerAuditApi } from '@/api/pendingRevies'
import { Dialog, Toast, Notify } from 'vant'
import i18n from '@/i18n'
export default {
  data () {
    return {
      reviewInfo: {},
      isLoading: false
    }
  },
  filters: {
    formatStatus (val) {
      return val === 1 ? i18n.t('shared.pendingReview') : val === 10 ? i18n.t('shared.approved') : val === -1 ? i18n.t('shared.rejected') : ''
    },
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    }
  },
  activated () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      auditInfoApi(this.$route.query.reviewId).then(res => {
        Toast.clear()
        this.reviewInfo = res.data
      })
    },
    handleOper (type) {
      this.isLoading = true
      // 审核通过将解除门店权限并将该门店转移到“拓展”区，此前的操作记录自动归档不可修改，请谨慎操作。
      let tips = `<div><i class="van-icon van-icon-info-o" style="font-size: 48px; color: #c4200b; margin-bottom: 15px;"></i><div style="line-height: 1.5;">${this.$t('tips.messageTwentyNine')}.</div></div>`
      if (type === 'refuse') {
        // 驳回 ${this.reviewInfo.createUserName} 的放弃门店申请，是否确认操作。
        tips = `<div><i class="van-icon van-icon-info-o" style="font-size: 48px; color: #c4200b; margin-bottom: 15px;"></i><div style="line-height: 1.5;">${this.$t('tips.messageThirty', { createUserName: this.reviewInfo.createUserName })}.</div></div>`
      }
      Dialog.confirm({
        message: tips,
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          Toast.loading({
            message: this.$t('shared.loading'),
            forbidClick: true,
            duration: 0
          })
          const data = {
            auditId: this.reviewInfo.id,
            status: type === 'refuse' ? -1 : 10
          }
          auditCheckGiveUpCustomerAuditApi(data).then(res => {
            Toast.clear()
            Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
            this.getInfo()
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        })
        .catch(() => {
          // on cancel
          this.isLoading = false
        })
    },
    toPage (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.review-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail-info {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    .info-item {
      margin-bottom: 16px;
      .store-name {
        color: #307bff;
        text-decoration: underline;
      }
      .status-txt {
        color: #0db00b;
      }
      .status10 {
        color: #307bff;
      }
      .status_1 {
        color: #c4200b
      }
    }
  }
  .oper-bottom-btn {
    .left-btn {
      color: #c4200b;
    }
    .left-btn,
    .right-btn {
      font-size: 15px;
    }
  }
}
</style>
